import { stringToDate } from 'modules/core/lib/dates'

import type Status from 'modules/bookkeepers/store/models/Status'
import type { IncidenceChangeItem } from 'modules/payroll_bundle/lib/types'

const buildStatusChanges = (statusChanges: Status[]) => {
  return statusChanges.map(
    (statusChange: Status) =>
      ({
        id: 'status_updated',
        currentValue: {
          value: statusChange.attributes.status,
        },
        effectiveAt: stringToDate(statusChange.attributes.effective_at, 'backend_datetime'),
        changedBy: statusChange.attributes.changed_by_name ?? 'Factorial',
      } as IncidenceChangeItem)
  )
}

export default buildStatusChanges
